export const common = {
  appName: 'My Update',
  yes: 'Sim',
  no: 'Não',
  save: 'Salvar',
  cancel: 'Cancelar',
  loading: 'Carregando...',
  search: 'Buscar',
  searchPlaceholder: 'Digite para buscar...',
  name: 'Nome',
  status: 'Status',
  updatedAt: 'Atualizado em',
  statuses: {
    active: 'Ativo',
    inactive: 'Inativo',
  },
  errors: {
    required: 'Campo obrigatório',
    invalidEmail: 'E-mail inválido',
    network: 'Falha de conexão. Tente novamente.',
  },
  data: {
    dia: 'Dia',
    mes: 'Mês',
    ano: 'Ano',
    diaPlaceholder: 'dd',
    mesPlaceholder: 'mm',
    anoPlaceholder: 'aaaa',
  },
  nav: {
    sidebar: 'Barra lateral',
    inicio: 'Início',
    campanhas: 'Campanhas',
    responder: 'Responder campanha',
    usuarios: 'Usuários e perfis',
    language: 'Idioma',
    theme: 'Tema',
    userMenu: 'Menu do usuário',
  },
  themes: {
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
  },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você procura não existe ou foi movida.',
    back: 'Voltar para a página inicial',
  },
  errorBoundary: {
    title: 'Algo deu errado',
    description: 'Ocorreu um erro inesperado. Recarregue a página e tente novamente.',
    reload: 'Recarregar',
  },
  tableFilters: {
    trigger: 'Filtrar por {{column}}',
    triggerActive: 'Filtrar por {{column}} (filtro aplicado)',
    title: 'Filtrar {{column}}',
    apply: 'Aplicar',
    clear: 'Limpar',
    textPlaceholder: 'Contém…',
    textInputLabel: 'Texto para filtrar {{column}}',
    optionsSearchPlaceholder: 'Buscar…',
    optionsSearchLabel: 'Buscar em {{column}}',
    optionsEmpty: 'Nada encontrado para "{{query}}".',
    min: 'Mínimo',
    max: 'Máximo',
  },
  close: 'Fechar',
} as const;
